import { render, staticRenderFns } from "./ShowcaseView.vue?vue&type=template&id=2c009ef6"
import script from "./ShowcaseView.vue?vue&type=script&lang=js"
export * from "./ShowcaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports